export default __webpack_public_path__ + "static/media/bano-mobile.bab57024.png";